import axios from "axios";

const catalogCache = new Map();

/**
 * Realiza una petición POST y almacena el resultado en caché.
 * Si la petición ya fue realizada con la misma URL y parámetros,
 * devuelve inmediatamente el resultado en caché sin hacer petición de red.
 * Si forceRefresh es true, ignora la caché existente y actualiza con datos frescos.
 */
export function fetchCachedCatalog(url, params = {}, forceRefresh = false) {
  const cacheKey = `${url}:${JSON.stringify(params)}`;
  if (!forceRefresh && catalogCache.has(cacheKey)) {
    return Promise.resolve(catalogCache.get(cacheKey));
  }
  return axios.post(url, params).then((response) => {
    catalogCache.set(cacheKey, response);
    return response;
  });
}

/**
 * Limpia la caché de catálogos.
 * Si se pasa un patrón/nombre de entidad (ej: 'medio', 'producto', 'operador'),
 * elimina todas las entradas que coincidan con dicho patrón.
 * Si no se especifica, limpia toda la caché.
 */
export function clearCatalogCache(pattern = null) {
  if (!pattern) {
    catalogCache.clear();
    return;
  }
  const needle = String(pattern).toLowerCase();
  for (const key of catalogCache.keys()) {
    if (key.toLowerCase().includes(needle)) {
      catalogCache.delete(key);
    }
  }
}

/**
 * Invalida la caché de una entidad específica.
 */
export function invalidateCatalog(entityName) {
  clearCatalogCache(entityName);
}
